import { Box, Chip, Paper, Stack, Typography } from "@mui/material";
import { statusStyleMap } from "./WorkerAccessCardHelper";
import { CalendarToday } from "@mui/icons-material";
import { formatDate } from "utils/functions";

export type Activity = {
  code: string;
  name: string;
  status: string;
  dueDate: string;
};

export const ActivityCard = ({ activity }: { activity: Activity }) => {
  const statusKey = activity.status.toLowerCase().replace(/[áàãâä]/g, 'a').replace(/[éèêë]/g, 'e').replace(/[íìîï]/g, 'i').replace(/[óòõôö]/g, 'o').replace(/[úùûü]/g, 'u').replace(/[ç]/g, 'c');
  const chipStyle = statusStyleMap[statusKey] || statusStyleMap['default'];

  return (
    <Paper 
      elevation={2}
      sx={{ 
        p: 3, 
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        '&:hover': {
          elevation: 4,
          transform: 'translateY(-2px)',
          transition: 'all 0.2s ease-in-out'
        }
      }}
    >
      <Stack spacing={2}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 2 }}>
          <Box sx={{ minWidth: 0, flex: 1 }}>
            <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
              <Chip 
                label={activity.code}
                size="small"
                variant="outlined"
                color="primary"
                sx={{ fontWeight: 'bold', borderRadius: 4 }}
              />
            </Stack>
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 600,
                fontSize: { xs: '1rem', sm: '1.1rem' },
                lineHeight: 1.3
              }}
            >
              {activity.name}
            </Typography>
          </Box>
          <Chip
            label={activity.status}
            size="small"
            variant="outlined"
            sx={{
              borderRadius: 4,
              py: 0.5,
              fontWeight: chipStyle.fontWeight,
              fontSize: '0.95em',
              bgcolor: chipStyle.bgcolor,
              color: chipStyle.color,
              borderColor: chipStyle.borderColor,
              boxShadow: 'none',
              textTransform: 'capitalize',
              borderWidth: 1,
            }}
          />
        </Box>

        <Stack 
          direction={{ xs: 'column', sm: 'row' }} 
          spacing={2}
          sx={{ pt: 1 }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CalendarToday sx={{ fontSize: 16, color: 'text.secondary' }} />
            <Typography variant="body2" color="text.secondary">
              <strong>Vencimento:</strong> {formatDate(new Date(activity.dueDate))}
            </Typography>
          </Box>
        </Stack>
      </Stack>
    </Paper>
  );
};
